import React from "react";

import { graphql, useStaticQuery } from "gatsby";

import filterByCategory from "./utils";
import MegaMenuResult from "../../components/megaMenuResult/megaMenuResult";
import KontentItemImage from "../kontentItemImage";

interface MegaMenuResultsNewsProps {
  item?: {
    categories?: string[];
  };
}

interface MegaMenuResultsNewsQuery {
  allKontentItemArticlePageNews: {
    nodes: Queries.kontent_item_article_page_news[];
  };
}

const MegaMenuResultsNews: React.FC<MegaMenuResultsNewsProps> = ({ item = null }) => {
  const data: MegaMenuResultsNewsQuery = useStaticQuery(graphql`
    {
      allKontentItemArticlePageNews(
        sort: {elements: {publishdate: {value: DESC}}},
        limit: 100
      ) {
        nodes {
          id
          elements {
            hero_image {
              value {
                ...KontentItemImage
              }
            }
            headline {
              value
            }
            news_category {
              value {
                codename
              }
            }
            publishdate {
              value
            }
          }
        }
      }
    }
  `);

  if (!data) {
    return null;
  }

  const filteredData = filterByCategory(
    data.allKontentItemArticlePageNews.nodes,
    "news_category",
    item?.categories || [],
  );

  const slicedData = filteredData.slice(0, 4);

  return (slicedData as Queries.kontent_item_article_page_news[]).map((e) => (
    <MegaMenuResult
      key={e.id}
      href={e.id}
      image={(
        <KontentItemImage
          data={e.elements?.hero_image?.value?.[0] as Queries.kontent_item_image}
          width={48}
          height={48}
          aspectRatio={1}
          fit="crop"
          defaultImage
        />
      )}
    >
      {e.elements?.headline?.value}
    </MegaMenuResult>
  ));
};

export default MegaMenuResultsNews;
